export class FaultMessageDto {
    constructor() {
        this.id = "";
        this.subsystem = "";
        this.timestamp = "";
        this.severity = "";
        this.description = "";
        this.data = [];
    }
    static fromJson(faultStructure) {
        let faultMessage = new FaultMessageDto();
        faultMessage.id = faultStructure[0];
        faultMessage.subsystem = faultStructure[1];
        faultMessage.timestamp = faultStructure[2];
        faultMessage.severity = faultStructure[3];
        faultMessage.description = faultStructure[4];
        faultMessage.data.push(...faultStructure.slice(5));
        return faultMessage;
    }
}
//# sourceMappingURL=FaultMessageDto.js.map